/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{camelToDash as r}from"../../render/dom/utils/camel-to-dash.js";const a="framerAppearId",e="data-"+r(a);export{e as optimizedAppearDataAttribute,a as optimizedAppearDataId};
//# sourceMappingURL=data-id.js.map
